import { logger, GENERIC_ERROR_MESSAGE, isBrowser } from 'common-ui';
import type { ErrorResponse } from 'tsconfig/types';
import { useAuthStore } from '../../stores/authStore';
import { useCartStore } from '../../stores/cartStore';
import { getCurrentCartIdFromCookie } from '../../helpers/utils';
import { handleExistingCartId, handleNewCartId } from '../../services/cart';

export function useInitCartStateWithWebApi() {
  return async (): Promise<void> => {
    if (!isBrowser()) {
      logger.log('useInitCartStateWithWebApi skipping fetch as not in browser');
      return;
    }

    const { cartItems } = useCartStore.getState().cart;
    if (cartItems) {
      logger.log('skipping init fetch of cart data as already defined');
      return;
    }

    try {
      const { cartId } = getCurrentCartIdFromCookie();
      const authAtomState = useAuthStore.getState().auth;
      const cartHandler = cartId ? handleExistingCartId : handleNewCartId;
      await cartHandler(authAtomState);
    } catch (error: unknown) {
      const apiError = error as ErrorResponse;
      useCartStore.getState().updateCart(prevState => ({
        ...prevState,
        cartIsLoaded: true,
        cartError: {
          hasCartError: true,
          cartErrorMessage: apiError?.message || GENERIC_ERROR_MESSAGE,
        },
      }));
      logger.error('Error during cart state initialization:', error);
    }
  };
}
